import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { memo } from 'react'
import { FieldArray } from 'react-final-form-arrays'

import useStyles from '../styles'
import LocationScansRow from './LocationScansRow'

const LocationScans = () => {
  const classes = useStyles()

  return (
    <>
      <Table className={classes.table}>
        <TableHead className={classes.tableHead}>
          <TableRow className={classes.headerRow}>
            <TableCell className={classes.headerCell}>Date</TableCell>
            <TableCell className={classes.headerCell}>Location</TableCell>
            <TableCell className={classes.headerCell}>User</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <FieldArray name="locationScans">
            {({ fields }) =>
              fields.map(fieldName => <LocationScansRow fieldName={fieldName} key={fieldName} />)
            }
          </FieldArray>
        </TableBody>
      </Table>
    </>
  )
}

export default memo(LocationScans)
